import { ReactNode } from "react";
import { PreviewExportMetadataModel } from "../Models/PreviewExportMetadataModel";
import { ProcedurePrivateFieldsModel } from "../Models/ProcedurePrivateFieldsModel";
import { PreviewExportModel } from "../Models/PreviewExportModel";
import { PreviewProcedureMetadataModel } from "../Models/PreviewProcedureMetadataModel";
import { PreviewMetadataMeasurement } from "../Models/PreviewMetadataMeasurement";
import { eAnatomicalLocationComponentType, Graft } from "../Models/Trigger/TriggerClasses";
import { PreviewProcedureModel } from "../Models/PreviewProcedureModel";
import { PreviewMeasurement } from "../Models/PreviewMeasurement";
import { ReferenceValueItemModel } from "../Models/ReferenceValueItemModel";
import { ReferenceValuesModel } from "../Models/ReferenceValuesModel";
import { StudyModel } from "../Models/StudyModel";


export enum AppMode {
  Home,             //0
  Search,           //1
  Export,           //2
  Upload,           //3
  Settings,         //4
  User,             //5
  AddUser,          //6
  Study,            //7
  Default,          //8
  Labels,           //9
  Report,           //10
  DashboardControl, //11
  Edit,             //12
  SelectedHome,     //13
  UploadHome,       //14
  UsageHistory,     //15
  ImportHistory,     //16
  CurrentLogons,     //17
  LabelMap,           //18
  UserHistorySummary, //19
  SitesSummary,       //20
  StudyUsageHistory   //21
};

export enum viewType{
  Advanced = "Advanced",
  Minimal = "Minimal"
}

export enum viewMode{
  Intui = "Intui",
  Legacy = "Legacy"
}

export enum studyTypes{
  None = "None",
  Cardiac = "Cardiac",
  Vascular = "Vascular"
}

export const studyTypeOptions: string[] = Object.values(studyTypes);

export class TileRange {
  min: number = 0;
  max: number = 0;
}

export class DataGridRow 
{
  index: number= 0; 
  children?: DataGridRow[]; 
}

export class DataGridColumn
{
  Name: string = "";
  Caption: string = "";
  
  Type?: string;
  FilterOptions?:string[];
  Editable?: boolean;
  ValueList?: string[];
  ignoreChildren?: boolean;
  searchChildren?: boolean;
  additionalChildClass?: string;
  hidden?: boolean;
  GetValueList?: (row: any)=> string[];
  RenderTemplate?: (item: any, rowItem: any, parentRow: any) => ReactNode;
  FilterTemplate?: (item: any)=>ReactNode;
  GetCellEdit?:(row:DataGridRow, column:DataGridColumn)=>boolean;
  //Defines if the value of the column is only shown once per alternate row group (See getChildGridRowAlternateColor in DataGrid) in the column 
  ShowValueOncePerAlternate?: boolean = false;
  AdditionalFilter?: (item: any)=>ReactNode;
  SummaryTemplate?: (rows: DataGridRow[])=>ReactNode;
  overrideFilter?: string;
  isPrivate?: boolean = false;
  
}


export class SortVal{
  category:string="";
  value:any;
  valueEnd:any;
  measurementType?:string="";
  capiton:string="";
  overrideType?: string = "";
  ignoreChildren?: boolean = false;
  searchChildren?: boolean = false;
  opposite?: boolean = false;
}

export class Helper {

  public static isPowerOf2(value: number): boolean {
    return (value & (value - 1)) === 0;
  }
}
export class Vertex {
  constructor(_x:number, _y:number, _z:number, _tu:number, _tv:number ) 
  {
    this.x = _x;
    this.y = _y;
    this.z = _z;
    this.tu = _tu;
    this.tv = _tv;
  }
  x: number;
  y: number;
  z: number;
  tu: number = 0;
  tv: number = 0;
  getVectoryArray(): number[] 
  {
    return [this.x, this.y, this.z];
  }
}

export class Coordinate {
  x: number = 0;
  y: number = 0;
  angle?: number;
}

export class Area extends Coordinate {
  width: number = 0;
  height: number = 0;
}

export class UploadDataHelper{
  
  
    GetDateFromElement = (element: Element | undefined) : Date =>
    {
      if (element)
      {
      let year = 0;
      let month = 1;
      let day = 0;
      let hour = 0;
      let minute = 0;
      let second = 0;
        if (element.getElementsByTagName("Year").length > 0)
        {
          year =  parseInt(element.getElementsByTagName("Year")[0].childNodes[0].nodeValue as string);
        }
        if (element.getElementsByTagName("Month").length > 0)
        {
          month =  parseInt(element.getElementsByTagName("Month")[0].childNodes[0].nodeValue as string);
        }
        if (element.getElementsByTagName("Day").length > 0)
        {
          day =  parseInt(element.getElementsByTagName("Day")[0].childNodes[0].nodeValue as string);
        }
        if (element.getElementsByTagName("Hour").length > 0)
        {
          hour =  parseInt(element.getElementsByTagName("Hour")[0].childNodes[0].nodeValue as string);
        }
        if (element.getElementsByTagName("Minute").length > 0)
        {
          minute =  parseInt(element.getElementsByTagName("Minute")[0].childNodes[0].nodeValue as string);
        }
        if (element.getElementsByTagName("Second").length > 0)
        {
          second =  parseInt(element.getElementsByTagName("Second")[0].childNodes[0].nodeValue as string);
        }
          let dateOut = new Date(Date.UTC(year, month-1, day, hour, minute, second, 0));
        return dateOut;
      }
      else
      //TODO: when the date should not return todays date!
      return new Date();
    }
  
    ParseNumber (valueIn: string): number 
    {
      if (!valueIn)
        return 0;
      return parseFloat(valueIn.replace(/,/, '.'));
    }
  
    ParseDate  (valueIn: string): Date 
    {
      let basicParse = Date.parse(valueIn);
      if (basicParse && basicParse !== 0 && !Number.isNaN(basicParse))
      {
          return new Date(basicParse);
      }else
      {
        //This is dodgy but lets try tweak the date a little and then parse it. This will work for this format: 21.03.2023 12:36:31
  
        const datetimeparts = valueIn.split(/[.\-/: ]+/);
        //We work on the assumption that day comes before month because we can't know otherwise.
        var dayindex = 0;
        var monthindex = 1;
        var yearindex = 2;
        var hourindex = 3;
        var minuteindex = 4;
        var secondindex = 5;
        //This will give us a list of numbers we hope.
        if (datetimeparts.length === 6) //There should be year, months, days, hours, minutes seconds
        {
            for (let index = 0; index < datetimeparts.length; index++) {
              const element = datetimeparts[index];
              if (element.length === 4)
              {
                  yearindex = index;
              }
  
            }
            if (yearindex === 0)
            {
  
              dayindex = 2;
              monthindex = 1;
              
            }
            //we check just in case month and day are swapped.
            if ( parseInt(datetimeparts[monthindex]) > 12 )
            {
              var tempMonthIndex = monthindex;
              monthindex = dayindex;
              dayindex = tempMonthIndex;
            }
            
            let correctedString = datetimeparts[dayindex] + "-" + datetimeparts[monthindex] + "-" + datetimeparts[yearindex] + "T" + datetimeparts[hourindex] + ":" + datetimeparts[minuteindex] +":" + datetimeparts[secondindex];
            basicParse = Date.parse(correctedString);
            if (basicParse as any !== "Invalid Date" && basicParse > 0)
            {
                return new Date(basicParse);
            }else
            {
              let outDate = new Date(parseInt(datetimeparts[yearindex]),parseInt(datetimeparts[monthindex]) -1,parseInt(datetimeparts[dayindex]),parseInt(datetimeparts[hourindex]), parseInt(datetimeparts[minuteindex]), parseInt(datetimeparts[secondindex]));
              if (outDate as any !== "Invalid Date")
                {
                    return outDate;
                }
            }
        }
      }
      //Kinda OK assumption that if we can't figure out the date then we use the current date.
      return new Date(Date.now());
    }
  
  
    GetIndexValue(element: Element, nodeName: string): number
    {
          if (element && element.children.length > 0)
          {
              for (let index = 0; index < element.children.length; index++) {
                const childelement = element.children[index];
                if (this.getElementValue(childelement, "Name") === nodeName)
                    return this.ParseNumber(this.getElementValue(childelement, "Value"));
              }
          }
          return 0.0;
    }
  
  
    GenerateIntuiLocationDefintions = (element: Element, nodeName: string, LabelsLookup: any, IntuiLabelsLookup: any) =>
    {
      let outputLookup: any = {};
      let nodesList = this.getFirstChildElement(element, nodeName + "s") as Element;
      if (nodesList)
      {
      for (let index = 0; index < nodesList.children.length; index++) {
        const childelement =  nodesList.children[index] as Element;
        
        let graftOut = this.processLocationToGraft(childelement, LabelsLookup, IntuiLabelsLookup);
        //outputLookup[locationId] = graftOut;
        this.recurseGraftAndAddSelected(graftOut, graftOut, outputLookup);
        //Now look through the child grafts and add a selected version for each.
  
      }
    }
      return outputLookup;
         
    }
  
    recurseGraftAndAddSelected = (mainGraft: Graft, currentGraft: Graft, outputLookup: any) =>
    {
        currentGraft.selected = true;
        let copyGraft = {...mainGraft};
        //Copy targets too
        copyGraft.targets = [];
        if (mainGraft.targets)
        for (let index = 0; index < mainGraft.targets.length; index++) {
            //duplicate child
            let copyChild = {...mainGraft.targets[index]};
            copyChild.targets = [];
            if (mainGraft.targets && mainGraft.targets[index] && mainGraft.targets[index].targets)
            {
              for (let index2 = 0; index2 < (mainGraft.targets[index].targets as any).length; index2++) {
                  //duplicate grandchild. We only go two layers deep as per Intui limitation.
                  let copyGrandChild = {...(mainGraft.targets[index].targets as any)[index2]};
                  copyChild.targets.push(copyGrandChild);
              }
            }
            copyGraft.targets.push(copyChild);
        }
        currentGraft.selected = false;
        outputLookup[currentGraft.id as string] =  copyGraft;
        if (currentGraft.targets)
        for (let index = 0; index < currentGraft.targets.length; index++) {
          const element = currentGraft.targets[index];
          this.recurseGraftAndAddSelected(mainGraft, element, outputLookup);
        }
    }
  
    LookUpNames = (element: Element, nodeName: string) =>
    {
      let outputLookup: any = {};
      let nodesList = this.getFirstChildElement(element, nodeName + "s") as Element;
      if (nodesList)
      {
      for (let index = 0; index < nodesList.children.length; index++) {
        const childelement =  nodesList.children[index] as Element;
  
        outputLookup[childelement.getAttribute("GUID") as string] = this.getElementValue(childelement,"Name");
      }
    }
      return outputLookup;
         
    }
    
  
    LookUpNamesDetail = (element: Element, nodeName: string) =>
    {
      let outputLookup: any = {};
      let nodesList = this.getFirstChildElement(element, nodeName + "s") as Element;
      if (nodesList)
      {
      for (let index = 0; index < nodesList.children.length; index++) {
        const childelement =  nodesList.children[index] as Element;
  
        outputLookup[childelement.getAttribute("GUID") as string] = {
          id: this.getElementValue(childelement,"Name"),
          name: this.getElementValue(childelement,"Name"),
          description: this.getElementValue(childelement,"OriginalName"),
          isAttribute: this.getElementValue(childelement,"IsAttribute") ?  this.getElementValue(childelement,"IsAttribute") : false,
          componentType: this.getElementValue(childelement,"ComponentType"),
          type: ""
        }
      }
    }
      return outputLookup;
         
    }
  
    LookUpIntuiNames = () =>
    {
      let IntuiLabelsLookup: any = {};
      IntuiLabelsLookup["f7565d0f-478a-4cba-9487-eeaf2c8c3085"] = "AORTA";
      IntuiLabelsLookup["8F621F93-EDD9-4c39-B1DA-4770574A783C"] = "LITA";
      IntuiLabelsLookup["157C3168-F6D7-4f8e-BB97-2F82DA1BFF07"] = "LAD";
      IntuiLabelsLookup["294A8894-04D3-43ad-9F48-57E56A825A0B"] = "RA";
      IntuiLabelsLookup["49866FA2-495D-432E-A8AB-4F6EDD6171D8"] = "DIAG";
      IntuiLabelsLookup["E27AE377-7904-43D7-96DC-137434D545C2"] = "DIAG2";
      IntuiLabelsLookup["E41DDFE5-F03B-4a55-B653-8A29FC43701C"] = "RITA";
      IntuiLabelsLookup["C73CFF10-CC3C-4230-B6C0-60F011E1D85A"] = "GEA";
      IntuiLabelsLookup["6BF8DD59-3D32-4c44-B1DA-C02FA13E7813"] = "SVG";
      IntuiLabelsLookup["6F90616D-7A66-4f3a-A0E6-2BDA33ACCCCB"] = "CX";
      IntuiLabelsLookup["0664EBC4-56F7-4be2-A1C2-D502F6913DEE"] = "OM";
      IntuiLabelsLookup["90EF0589-4090-4e2f-A647-6AEDCC3451B3"] = "OM1";
      IntuiLabelsLookup["66F5A4AB-3FF4-4929-BB88-D7D9FE59C89B"] = "PDA";
      IntuiLabelsLookup["FFAE65B2-2708-435e-BD20-96BA93358DF8"] = "RCA";
      IntuiLabelsLookup["DC2974CD-29B1-4060-A6CE-5153819AAFE6"] = "RI";
      IntuiLabelsLookup["505662CA-015B-438F-BF97-082AC0F21635"] = "OM2";
      IntuiLabelsLookup["B8FF7A2D-4F08-46ED-A03C-E92237DA032A"] = "PLA";
      IntuiLabelsLookup["2D5EAA93-AA9C-4E3D-827A-0EC14DD45E5C"] = "RVB";
      IntuiLabelsLookup["675150D8-F3B7-46F4-B807-47713B1AC183"] = "AM";
      IntuiLabelsLookup["1E2AC560-4914-4860-B9DC-F2CE72DCD699"] = "LVB";
      IntuiLabelsLookup["5F4D7C01-8FEE-4066-958C-E1E1E3782188"] = "Sequential";
      IntuiLabelsLookup["8CC4DF07-5165-485d-9AF0-FD6A99B6EB21"] = "Y";
      IntuiLabelsLookup["27781168-AFD0-4b0d-8239-C91756108A3A"] = "InSitu";
      
      return IntuiLabelsLookup;
    }

    getElementValue = (element: Element, nodeName: string): string=>
    {
      for (let index = 0; index < element.getElementsByTagName(nodeName).length; index++) {
        const childelement = element.getElementsByTagName(nodeName)[index];
        if (childelement.parentNode === element)
        {
          return childelement.textContent as string;
        }
      }
      return "";
    }
  
    getFirstChildElement = (element: Element | undefined, nodeName: string): Element | undefined =>
    {
      if (element)
      {
    
      for (let index = 0; index < element.getElementsByTagName(nodeName).length; index++) {
        const childelement: Element = element.getElementsByTagName(nodeName)[index];
        if (childelement.parentNode === element)
        {
          return childelement;
        }
      }    
    }
    
    }
  
    getChildElements = (element: Element | undefined, nodeName: string): Element[] =>
    {
      let childrenOut: Element[] = [];
      if (element)
      {
    
      for (let index = 0; index < element.getElementsByTagName(nodeName).length; index++) {
        const childelement: Element = element.getElementsByTagName(nodeName)[index];
        if (childelement.parentNode === element)
        {
          childrenOut.push(childelement);
        }
      }   
   
    }
    return childrenOut; 
    }
  
  
    processLocationToGraft = (locationDefinitionElement: Element, LabelsLookup: any, IntuiLabelsLookup: any): Graft => 
    {
        let GraftOut: Graft = Graft.getBlankGraft();
        GraftOut.id = locationDefinitionElement.getAttribute("GUID") as string;
        //Set currrent graft from Components Node
        let components =  this.getFirstChildElement(locationDefinitionElement, "Components");
        let componentList = this.getChildElements(components, "Component");
        for (let index = 0; index < componentList.length; index++) {
          const componentElement = componentList[index];
          let componentGuid = componentElement.getAttribute("GUID") as string;
          let componentTypeStr = (this.getElementValue(componentElement, "ComponentType"));
          let componentType: eAnatomicalLocationComponentType = eAnatomicalLocationComponentType.TypeGeneralLocation;
          if (componentTypeStr)
          {
            componentType = Number(componentTypeStr);
          }
          if (LabelsLookup[componentGuid])
          {
              if (componentType === eAnatomicalLocationComponentType.TypeGeneralLocation)
              {
                  GraftOut.type = "PreGraft";
                  GraftOut.name = IntuiLabelsLookup[componentGuid] ? IntuiLabelsLookup[componentGuid] : LabelsLookup[componentGuid].name;
                  GraftOut.title = LabelsLookup[componentGuid].name;
              }
              if (componentType === eAnatomicalLocationComponentType.TypeGraftConduit)
              {
                  GraftOut.type = "Conduit";
                  if (componentList.length === 1)
                  {
                     GraftOut.type = "Source";
                     GraftOut.inSitu = true;
                  }
                  let componentName = IntuiLabelsLookup[componentGuid] ? IntuiLabelsLookup[componentGuid] : LabelsLookup[componentGuid].name;
                  if (componentName === "Aorta")
                  {
                    GraftOut.inSitu = false;
                  } 
                  if (componentName === "InSitu")
                  {
                     GraftOut.inSitu = true;
                  }
                  GraftOut.conduit = IntuiLabelsLookup[componentGuid] ? IntuiLabelsLookup[componentGuid] : LabelsLookup[componentGuid].name;
                  GraftOut.title = LabelsLookup[componentGuid].name;
              }if (componentType === eAnatomicalLocationComponentType.TypeAnastomosisSite)
              {
                  GraftOut.type = "Target";
                  GraftOut.name = IntuiLabelsLookup[componentGuid] ? IntuiLabelsLookup[componentGuid] : LabelsLookup[componentGuid].name;
                  GraftOut.title = LabelsLookup[componentGuid].name;
              }
              if (componentType === eAnatomicalLocationComponentType.TypeAttribute)
              {
                 let componentName = IntuiLabelsLookup[componentGuid] ? IntuiLabelsLookup[componentGuid] : LabelsLookup[componentGuid].name;
                  if (componentName === "Sequential")
                  {
                      GraftOut.sequential = true;
                  }else
                  {
                     GraftOut.sequential = false;
                  }
              }
          }
        }
        
  
        //Then build children from locations nodes
        let childLocations = this.getFirstChildElement(locationDefinitionElement, "Locations");
        if (childLocations)
        {
            GraftOut.targets = [];
            for (let index = 0; index < childLocations.getElementsByTagName("Location").length; index++) {
            const childelement: Element = childLocations.getElementsByTagName("Location")[index];
            if (childelement.parentNode === childLocations)
            {
                let GraftChild: Graft = this.processLocationToGraft(childelement, LabelsLookup, IntuiLabelsLookup);
                if (GraftOut.conduit as string === "Aorta")
                {
                  GraftOut.conduit = GraftChild.conduit;
                }
                GraftOut.targets.push(GraftChild);
            }
      
        }
      }  
        
        return GraftOut;
    }
  
    processProcedureNode = (userId: string, softwareVersion: string, isIntui: boolean, patientElement: Element, indexProc: number, systemId: string, hospitalName: string, AnatomicalLocationLookup: any, VesselComponentLookup: any, VesselComponentLookupDetail: any,  MeasurementTypeLookup: any, LabelsLookup: any, IntuiLocationDefinitionsLookup: any, SurgeonLookup: any, ProjectLookup: any, otherFiles: File[]): PreviewProcedureModel[] =>
    {
        let proceduresAll: PreviewProcedureModel[] = [];
        //The procedureElement is the PatientNode
        let patientcommentsWorking = this.getElementValue(patientElement, "Comments");
        let patientidWorking = this.getElementValue(patientElement, "PatientIdentifier");
  
        let heightWorking = this.ParseNumber(this.getElementValue(patientElement, "Height"));
        let weightWorking = this.ParseNumber(this.getElementValue(patientElement, "Weight"));
        let genderWorking = this.ParseNumber(this.getElementValue(patientElement, "Gender"));
        let dobWorking = this.getFirstChildElement(patientElement, "BirthDate") as Element;
        let birthYearWorking = 0;
        if (dobWorking.getElementsByTagName("Year").length > 0)
        {
          try {
  
          
          let year =  parseInt(dobWorking.getElementsByTagName("Year")[0].childNodes[0].nodeValue as string);
          
          birthYearWorking = year;
          }catch (exparse)
          {
            console.log("Parsing date failed.")
          }
        }
        //Assume single case per patient?
        let caseNodes = this.getChildElements(this.getFirstChildElement(patientElement, "Cases"), "Case");// patientElement.getElementsByTagName("Cases")[0].getElementsByTagName("Case")[0];
        for (let index = 0; index < caseNodes.length; index++) {
        const caseNode = caseNodes[index];
        let caseId = caseNode.getAttribute("GUID");
        let caseComments = this.getElementValue(caseNode, "Comments");
        if (!caseComments)
        {
          //We lean towards populating a comment no matter what. The Patient Comment seems to be the most accessible one in the UI so use that if the case one is blank.
          caseComments = patientcommentsWorking;
        }
  
        let caseApplication = this.getElementValue(caseNode, "Application");
  
        let AnatomicalLocations: string[] = [];
        let startTime = this.GetDateFromElement(this.getFirstChildElement(caseNode, "StartTime") as Element);
        let flowMeasurementsCount = 0;
        let imagingMeasurementsCount = 0;
        let missingData = false;
        let measurementsList: PreviewMeasurement[] = [];
        let measurementSets = this.getChildElements(this.getFirstChildElement(caseNode, "MeasurementSets"), "MeasurementSet");
        let measurementCount = 0;
  
        let SurgeonGuid = "";
        if ((this.getFirstChildElement(caseNode, "Surgeon") as Element))
          SurgeonGuid = (this.getFirstChildElement(caseNode, "Surgeon") as Element).getAttribute("GUID") as string;
        let SurgeonName = SurgeonGuid ?  SurgeonLookup[SurgeonGuid] : "";
  
        let ProjectsList: Element[] = [];
        if (this.getFirstChildElement(patientElement, "Projects"))
          ProjectsList = this.getChildElements(this.getFirstChildElement(patientElement, "Projects"), "Project");
        let ProjectName = "";
        for (let index = 0; index < ProjectsList.length; index++) {
          const element = ProjectsList[index];
          let ProjectGuid = element.getAttribute("GUID") as string;
          ProjectName += (ProjectName?";" : "") + ProjectLookup[ProjectGuid];
        }
      
  
        for (let index = 0; index < measurementSets.length; index++) {
          const measurementSetElement = measurementSets[index] as Element;
          
          let measurementSetIdCurrent = measurementSetElement.getAttribute("GUID") as string;
          let measurementSetIndexCurrent = index;
          let measurementQualified = this.getElementValue(measurementSetElement, "Qualified");
  
          let RecordedLength = this.ParseNumber(this.getElementValue(measurementSetElement, "RecordedLength"));
          let SweepLength = this.ParseNumber(this.getElementValue(measurementSetElement, "SweepLength"));
          let SweepPosition = this.ParseNumber(this.getElementValue(measurementSetElement, "SweepPosition"));
          let LeftCursor = this.ParseNumber(this.getElementValue(measurementSetElement, "LeftCursor"));
          let RightCursor = this.ParseNumber(this.getElementValue(measurementSetElement, "RightCursor"));
          let FrequencyRange = this.ParseNumber(this.getElementValue(measurementSetElement, "FrequencyRange"));
          let FrequencyOffset = this.ParseNumber(this.getElementValue(measurementSetElement, "FrequencyOffset"));
          let LeftFDCursor = this.ParseNumber(this.getElementValue(measurementSetElement, "LeftFDCursor"));
          let RightFDCursor = this.ParseNumber(this.getElementValue(measurementSetElement, "RightFDCursor"));
          let PlaybackCursor = this.ParseNumber(this.getElementValue(measurementSetElement, "PlaybackCursor"));
  
          let measurements = this.getChildElements(this.getFirstChildElement(measurementSetElement, "Measurements"), "Measurement");
          let MapMean = -1;
          let MapMax = -1;
          let MapMin = -1;
          let BpmMean = -1;
          let BpmMax = -1;
          let BpmMin = -1;
  
          //For Intui we try find the procedure and procedureStep
  
          let PerformedProcedureStepElement = (this.getFirstChildElement(measurementSetElement, "PerformedProcedureStep") as Element);
          let performedProcedure = "";
          let performedProcedureStep = "";
          if (PerformedProcedureStepElement)
          {
              performedProcedure = (this.getFirstChildElement(PerformedProcedureStepElement, "Procedure") as Element).getAttribute("GUID") as string;
              performedProcedureStep = (this.getFirstChildElement(PerformedProcedureStepElement, "ProcedureStep") as Element).getAttribute("GUID") as string;
          }
  
          //First lets try get the MAP and BPM from the other measurements
          for (let index = 0; index < measurements.length; index++) {
            const measurementElement = measurements[index] as Element;
            let measurementType = MeasurementTypeLookup[(this.getFirstChildElement(measurementElement, "MeasurementType") as Element).getAttribute("GUID") as string];
            if (measurementType === "Ecg")
            {
              BpmMean = this.GetIndexValue(this.getFirstChildElement(measurementElement, "Indices") as Element, "Mean");
              BpmMax = this.GetIndexValue(this.getFirstChildElement(measurementElement, "Indices") as Element, "Max");
              BpmMin = this.GetIndexValue(this.getFirstChildElement(measurementElement, "Indices") as Element, "Min");
            }
            if (measurementType === "Pressure")
            {
              MapMean = this.GetIndexValue(this.getFirstChildElement(measurementElement, "Indices") as Element, "Mean");
              MapMax = this.GetIndexValue(this.getFirstChildElement(measurementElement, "Indices") as Element, "Max");
              MapMin = this.GetIndexValue(this.getFirstChildElement(measurementElement, "Indices") as Element, "Min");
            }
          }
  
  
        for (let index = 0; index < measurements.length; index++) {
          let measurementAnatomy = [];
          let labelsIn = [];
          let vesselsList = [];
          const measurementElement = measurements[index] as Element;
          let GraftDefined: any;
          if (isIntui)
          {
              //For Intui we need to parse the graft into a Graft Class
              if ((this.getFirstChildElement(measurementElement, "Location") as Element))
              {
                  let locationGuid = (this.getFirstChildElement(measurementElement, "Location") as Element).getAttribute("GUID") as string;
                  GraftDefined = IntuiLocationDefinitionsLookup[locationGuid];
              }
  
          }
  
          let anatLocations = this.getChildElements(this.getFirstChildElement(this.getFirstChildElement(measurementElement, "AnatomicalLocation"), "AnatomicalLocationComponents"), "AnatomicalLocationComponent");
          for (let subindex = 0; subindex < anatLocations.length; subindex++) {
            const anatelement = anatLocations[subindex];
            if (AnatomicalLocationLookup[anatelement.getAttribute("GUID") as string])
            {
              AnatomicalLocations.push(AnatomicalLocationLookup[anatelement.getAttribute("GUID") as string] );
              measurementAnatomy.push(AnatomicalLocationLookup[anatelement.getAttribute("GUID") as string]);
            }
            if (LabelsLookup[anatelement.getAttribute("GUID") as string])
            {
              labelsIn.push(LabelsLookup[anatelement.getAttribute("GUID") as string] );
            }
          }
          let vessels = this.getChildElements(this.getFirstChildElement(this.getFirstChildElement(measurementElement, "Graft"), "VesselComponents"), "VesselComponent");
          for (let subindex = 0; subindex < vessels.length; subindex++) {
            const vesselelement = vessels[subindex];
            if (VesselComponentLookup[vesselelement.getAttribute("GUID") as string])
            {
              vesselsList.push(VesselComponentLookup[vesselelement.getAttribute("GUID") as string]);
            }
            if (VesselComponentLookupDetail[vesselelement.getAttribute("GUID") as string])
            {
              labelsIn.push(VesselComponentLookupDetail[vesselelement.getAttribute("GUID") as string] );
            }
            
          }
          let savedTime = this.GetDateFromElement(this.getFirstChildElement(measurementSetElement, "TimeSaved"));
          let measurementTypeGuid = (this.getFirstChildElement(measurementElement, "MeasurementType") as Element).getAttribute("GUID") as string;
          let measurementType = MeasurementTypeLookup[measurementTypeGuid];
  
          let commentsIn = this.getElementValue(measurementElement, "Comments");
          let commentsSetIn = this.getElementValue(measurementSetElement, "Comments");
  
   
          let measurementId = measurementElement.getAttribute("GUID") as string;
          let indexConfigNode = this.getFirstChildElement(measurementElement, "IndexConfiguration");
          let indexConfigurationId = "";
          let useColorGrading = false;
          if (indexConfigNode)
          {
            //TODO: Need to support UseColorGrading eventually but not sure what it means.
            indexConfigurationId = indexConfigNode.getAttribute("GUID") as string;
            useColorGrading = this.getElementValue(indexConfigNode, "IsColorGraded") === "true";
          }
          //Now check for Missing data
          let hasDataFile = otherFiles.filter((item)=> { return item.name.startsWith(measurementId)}).length > 0;
          let newLabelList = [];
          let labelsAdded = [];
          //Remove label duplicates
          for (let index = 0; index < labelsIn.length; index++) {
            const element = labelsIn[index];
            if (labelsAdded.indexOf(element.id) === -1)
            {
              labelsAdded.push(element.id);
              newLabelList.push(element);
            }
          
          }
          
          let previewMeasurement: PreviewMeasurement =
          {
            index: measurementCount,
            id: measurementId,
            comments: commentsIn,
            setComments: commentsSetIn,
            measurementType: measurementType,
            measurementTypeGuid: measurementTypeGuid, 
            recordDate: savedTime,
            anatomicalLocations: measurementAnatomy,
            labels: newLabelList,
            qualified: measurementQualified === "true" ? true : false,
            missingData: !hasDataFile,
            vessels: vesselsList, 
            measurementSetId: measurementSetIdCurrent,
            measurementSetIndex: measurementSetIndexCurrent,
            recordedLength:		RecordedLength,
            sweepLength:		SweepLength,
            sweepPosition:		SweepPosition, 
            leftCursor:			LeftCursor,
            rightCursor:		RightCursor, 
            frequencyRange:		FrequencyRange,
            frequencyOffset:	FrequencyOffset,
            leftFDCursor:		LeftFDCursor,
            rightFDCursor:		RightFDCursor ,
            playbackCursor:		PlaybackCursor,
            performedProcedure: performedProcedure,
            performedProcedureStep: performedProcedureStep,
            indexConfigurationId: indexConfigurationId,
            indicesColorGraded: useColorGrading,
            intuiGraft: GraftDefined
          }
          if (!hasDataFile)
          {
            missingData= true;
          }
          previewMeasurement.isIntui = isIntui;
          if (measurementType === "Flow")
          {
            flowMeasurementsCount++;
            if (isIntui)
            {
              previewMeasurement.mean = this.GetIndexValue(this.getFirstChildElement(measurementElement, "Indices") as Element, "MF");
              previewMeasurement.pI = this.GetIndexValue(this.getFirstChildElement(measurementElement, "Indices") as Element, "PI");
              previewMeasurement.dF = this.GetIndexValue(this.getFirstChildElement(measurementElement, "Indices") as Element, "DF");
              previewMeasurement.insuf = this.GetIndexValue(this.getFirstChildElement(measurementElement, "Indices") as Element, "BF");
            }else
            {
              previewMeasurement.mean = this.GetIndexValue(this.getFirstChildElement(measurementElement, "Indices") as Element, "Mean");
              previewMeasurement.pI = this.GetIndexValue(this.getFirstChildElement(measurementElement, "Indices") as Element, "PI");
              previewMeasurement.dF = this.GetIndexValue(this.getFirstChildElement(measurementElement, "Indices") as Element, "DF");
              previewMeasurement.insuf = this.GetIndexValue(this.getFirstChildElement(measurementElement, "Indices") as Element, "Insuf");
            }
          }else  if (measurementType === "Imaging")
          {
            imagingMeasurementsCount++;
          }
          if (BpmMean > -1)
          previewMeasurement.bPMMean = BpmMean;
          if (BpmMax > -1)
          previewMeasurement.bPMMax = BpmMax;
          if (BpmMin > -1)
          previewMeasurement.bPMMin = BpmMin;
          if (MapMean > -1)
          previewMeasurement.mAPMean = MapMean;
          if (MapMax > -1)
          previewMeasurement.mAPMax = MapMax;
          if (MapMin > -1)
          previewMeasurement.mAPMin = MapMin;
  
          measurementsList.push(previewMeasurement);
          measurementCount++;
        }
  
      }
        let procedureOut: PreviewProcedureModel =
        {
          id: caseId as string,
          userId: userId,
          patientId: patientidWorking,
          systemId: systemId,
          comments: caseComments,
          patientComments: patientcommentsWorking,
          anatomicalLocations: AnatomicalLocations,
          createdDate: startTime,
          flowMeasurements: flowMeasurementsCount,
          imagingMeasurements: imagingMeasurementsCount,
          pWMeasurements: 0,
          reports: 0,
          missingData: missingData,
          selected: false,
          measurements: measurementsList,
          hospitalName: hospitalName,
          index: indexProc,
          weight: weightWorking,
          height: heightWorking,
          gender: genderWorking,
          bmi: heightWorking > 0 ? (weightWorking/(heightWorking*heightWorking)) : 0,
          birthYear: birthYearWorking,
          surgeon: SurgeonName,
          projects: ProjectName, 
          sideUsed: "",
          softwareVersion: softwareVersion,
          application: caseApplication,
          overrideId: ""
        };
        proceduresAll.push(procedureOut);
      }
      return proceduresAll;
    }
  
  processProcedureNodePrivateFields = (patientElement: Element, indexProc: number): ProcedurePrivateFieldsModel[] =>
    {
        let proceduresAll: ProcedurePrivateFieldsModel[] = [];
        //The procedureElement is the PatientNode
        let patientidWorking = this.getElementValue(patientElement, "PatientIdentifier");
        let patientName= this.getElementValue(patientElement, "Name");
        let dobWorking = this.GetDateFromElement(this.getFirstChildElement(patientElement, "BirthDate") as Element);
      
        
      let caseNodes = this.getChildElements(this.getFirstChildElement(patientElement, "Cases"), "Case");// patientElement.getElementsByTagName("Cases")[0].getElementsByTagName("Case")[0];
          for (let index = 0; index < caseNodes.length; index++) {
          const caseNode = caseNodes[index];
          let caseId = caseNode.getAttribute("GUID");
            let procedureDate = this.GetDateFromElement(this.getFirstChildElement(caseNode, "StartTime") as Element);
          let procedureOut: ProcedurePrivateFieldsModel =
          {
            id: caseId as string,
            index: indexProc,
            name: patientName,
            patientId: patientidWorking,
            dateofbirth: dobWorking,
            procedureDate: procedureDate
          };
          proceduresAll.push(procedureOut);
        
      }
      return proceduresAll;
    }
  
    getColorFromGrade = (gradeValue: string): string => 
    {
      if (gradeValue === "0")
        return "";
      if (gradeValue === "1")
        return "var(--GreenApple)";
      if (gradeValue === "2")
        return "var(--BananaClan)";
      if (gradeValue === "3")
        return "var(--BernRed)";
      return "";
    }
    
    parseIndexGradings = (indexGradings: Element | null): any => 
    {
        if (!indexGradings) return {};
        let indexesOut: any = {};
        let indexGradingNodes = this.getChildElements(indexGradings, "IndexGrading");
        for (let index = 0; index < indexGradingNodes.length; index++) {
          const element = indexGradingNodes[index];
          let id = element.getAttribute("GUID");
          let zone1_max = this.getElementValue(element, "Zone1_Max");
          let zone1_min = this.getElementValue(element, "Zone1_Min");
          let zone0_grade = this.getElementValue(element, "Zone0_Grade");
          let zone1_grade = this.getElementValue(element, "Zone1_Grade");
          let zone2_grade = this.getElementValue(element, "Zone2_Grade");

          let refvalItemModel: ReferenceValueItemModel =
          {
            lowerReferenceValue: this.ParseNumber(zone1_min),
            upperReferenceValue: this.ParseNumber(zone1_max),
            goodColor: this.getColorFromGrade(zone2_grade),
            badColor: this.getColorFromGrade(zone1_grade),
            worstColor: this.getColorFromGrade(zone0_grade)
          }


          if (id)
            indexesOut[id as string] = refvalItemModel;
        }
        return indexesOut;
    }

    getDefaultIndexConfiguration = (studyIndices: StudyModel): ReferenceValuesModel =>
    {
      let refValues: ReferenceValuesModel =
       {
                id: "DEFAULTCASECLOUD",
                aciLowerReferenceValue: studyIndices.aciLowerReferenceValue ? studyIndices.aciLowerReferenceValue : 20,
                aciUpperReferenceValue: studyIndices.aciUpperReferenceValue ? studyIndices.aciUpperReferenceValue : 50,
                aciWorstColor: studyIndices.aciWorstColor || "var(--newDolphin)",
                aciBadColor: studyIndices.aciBadColor || "var(--newDolphin)",
                aciGoodColor: studyIndices.aciGoodColor || "var(--newDolphin)",
                meanLowerReferenceValue: studyIndices.lowerReferenceValue || 15,
                meanUpperReferenceValue: studyIndices.upperReferenceValue || 30,
                meanWorstColor: studyIndices.meanWorstColor || "var(--newDolphin)",
                meanBadColor: studyIndices.meanBadColor || "var(--newDolphin)",
                meanGoodColor: studyIndices.meanGoodColor || "var(--newDolphin)",
                piLowerReferenceValue: studyIndices.piLowerReferenceValue ||3,
                piUpperReferenceValue: studyIndices.piUpperReferenceValue ||5,
                piWorstColor: studyIndices.piWorstColor || "var(--newDolphin)",
                piBadColor: studyIndices.piBadColor || "var(--newDolphin)",
                piGoodColor: studyIndices.piGoodColor || "var(--newDolphin)",
                dfLowerReferenceValue: studyIndices.dfLowerReferenceValue ||20,
                dfUpperReferenceValue: studyIndices.dfUpperReferenceValue ||50,
                dfWorstColor: studyIndices.dfWorstColor || "var(--newDolphin)",
                dfBadColor: studyIndices.dfBadColor || "var(--newDolphin)",
                dfGoodColor: studyIndices.dfGoodColor || "var(--newDolphin)",
                bfLowerReferenceValue: studyIndices.bfLowerReferenceValue ||20,
                bfUpperReferenceValue: studyIndices.bfUpperReferenceValue ||50,
                bfWorstColor: studyIndices.bfWorstColor || "var(--newDolphin)",
                bfBadColor: studyIndices.bfBadColor || "var(--newDolphin)",
                bfGoodColor: studyIndices.bfGoodColor || "var(--newDolphin)",

            };
            return refValues;
    }

    parseIndexConfigurations = (indexConfigsElement: Element, indexGradingsLookup: any) =>
    {
      let parsedIndexConfigs: ReferenceValuesModel[] = [];
      if (indexConfigsElement)
      {
      let indexConfigs = this.getChildElements(indexConfigsElement, "IndexConfiguration");
      for (let index = 0; index < indexConfigs.length; index++) {
        let indexConfig = indexConfigs[index];
        let id = indexConfig.getAttribute("GUID");
        let referencevalueItem: ReferenceValuesModel = {
          id: id as string
        };
        
        let presentations = this.getFirstChildElement(indexConfig, "Presentations");
        let indexPresentations = this.getChildElements(presentations, "IndexPresentation");
        for (let index = 0; index < indexPresentations.length; index++) {
          const element = indexPresentations[index];
          let indexGradingElement = this.getFirstChildElement(element, "IndexGrading");
          let idGrading = indexGradingElement?.getAttribute("GUID");
          let indexTypeElement = this.getFirstChildElement(element, "IndexType");
          let idType = indexTypeElement?.getAttribute("GUID");
          
          if (idGrading)
          {
            let indexGrading = indexGradingsLookup[idGrading] as ReferenceValueItemModel;
            if (indexGrading)
            {
              if (idType === "FA0D9175-1438-4136-9A4E-76DF8B39A9F1")//ACI
              {
                referencevalueItem.aciLowerReferenceValue = indexGrading.lowerReferenceValue;
                referencevalueItem.aciUpperReferenceValue = indexGrading.upperReferenceValue;
                referencevalueItem.aciBadColor = indexGrading.badColor;
                referencevalueItem.aciGoodColor = indexGrading.goodColor;
                referencevalueItem.aciWorstColor = indexGrading.worstColor;
              }
              if (idType === "7DF6C126-5021-4d4d-9CF4-443F2B281FAD")//Mean
              {
                //Mean values are stored as L/min so we multiply by 1000 to get mL/min which is what we use in the UI and what Intui stores them as.
                referencevalueItem.meanLowerReferenceValue = (indexGrading.lowerReferenceValue || 0)*1000;
                referencevalueItem.meanUpperReferenceValue = (indexGrading.upperReferenceValue || 0)*1000;
                referencevalueItem.meanBadColor = indexGrading.badColor;
                referencevalueItem.meanGoodColor = indexGrading.goodColor;
                referencevalueItem.meanWorstColor = indexGrading.worstColor;
              }
              if (idType === "C1685D6E-79F2-4c9e-824D-73D6FF56675A")//PI
              {
                referencevalueItem.piLowerReferenceValue = indexGrading.lowerReferenceValue;
                referencevalueItem.piUpperReferenceValue = indexGrading.upperReferenceValue;
                referencevalueItem.piBadColor = indexGrading.badColor;
                referencevalueItem.piGoodColor = indexGrading.worstColor;
                referencevalueItem.piWorstColor = indexGrading.goodColor;
              }
              if (idType === "95446420-2630-4f58-9F9F-E31636EE0D17")//DF
              {
                referencevalueItem.dfLowerReferenceValue = indexGrading.lowerReferenceValue;
                referencevalueItem.dfUpperReferenceValue = indexGrading.upperReferenceValue;
                referencevalueItem.dfBadColor = indexGrading.badColor;
                referencevalueItem.dfGoodColor = indexGrading.worstColor;
                referencevalueItem.dfWorstColor = indexGrading.goodColor;
              }
              if (idType === "61478A9E-4090-4830-90F9-E02B33B9562C")//BF
              {
                referencevalueItem.bfLowerReferenceValue = indexGrading.lowerReferenceValue;
                referencevalueItem.bfUpperReferenceValue = indexGrading.upperReferenceValue;
                referencevalueItem.bfBadColor = indexGrading.badColor;
                referencevalueItem.bfGoodColor = indexGrading.worstColor;
                referencevalueItem.bfWorstColor = indexGrading.goodColor;
              }
            } 
          }         
        }
        parsedIndexConfigs.push(referencevalueItem);
      }
    }
      return parsedIndexConfigs;
      
    }



    parseFullXmlFile = (studyId: string, userId: string,  userHospital: string, userType: string,allowFullDateOnly: boolean, xmlContent: string, otherFiles: File[], proceduresAll: PreviewProcedureMetadataModel[], proceduresAllFull: PreviewProcedureModel[]): {previewModel:PreviewExportModel, procedures: ProcedurePrivateFieldsModel[], metadata: PreviewExportMetadataModel} =>
    {
      let metadataModel: PreviewExportMetadataModel = {
        id: crypto.randomUUID(), procedures: proceduresAll,
        studyId:  studyId
      };
       let privateProcs: ProcedurePrivateFieldsModel[] = []; 
      let previewModel: PreviewExportModel = {
        id: crypto.randomUUID(),
        filename: "",
        serialNumber: "", 
        hospitalName: "",
        department: "",
        softwareVersion: "",
        procedures: proceduresAllFull,
        studySelected: "", 
        importDate: new Date(Date.now()),
        importLabel: "",
        confirmEmail: true, 
        includePatientId: false,
        includeDateTime: allowFullDateOnly as boolean,
        includeGenderHeightWeightAge: false,
        encryptionEnabled: false,
        referenceValues: []
      };
      let parser = new DOMParser();
     
       let xmlDoc = parser.parseFromString(xmlContent,"text/xml");
  
        let ClinicalData = this.getFirstChildElement(xmlDoc.getRootNode() as Element, "ClinicalData") as Element;
       let SystemInfo = this.getFirstChildElement(ClinicalData, "SystemInfo") as Element;
       previewModel.softwareVersion = this.getElementValue(SystemInfo, "SoftwareVersion");
      let isIntui = previewModel.softwareVersion && previewModel.softwareVersion.indexOf("4.4") > -1 ? true : false;
       previewModel.serialNumber = this.getElementValue(SystemInfo, "SystemSerialNumber");//xmlDoc.getElementsByTagName("SystemInfo")[0].getElementsByTagName("SystemSerialNumber")[0].childNodes[0].nodeValue as string;
       previewModel.exportDate = this.ParseDate(this.getElementValue(SystemInfo, "TimeOfExport"));// xmlDoc.getElementsByTagName("SystemInfo")[0].getElementsByTagName("TimeOfExport")[0].childNodes[0].nodeValue as string;
       previewModel.hospitalName = this.getElementValue(SystemInfo, "HospitalName");//xmlDoc.getElementsByTagName("SystemInfo")[0].getElementsByTagName("HospitalName")[0].childNodes[0].nodeValue as string;
      if(userType==="Uploader"){
        previewModel.hospitalName = userHospital
      }
       previewModel.department = this.getElementValue(SystemInfo, "Department");//xmlDoc.getElementsByTagName("SystemInfo")[0].getElementsByTagName("Department")[0].childNodes[0].nodeValue as string;
   
      let AnatomicalLocationLookup = this.LookUpNames(ClinicalData, "Component");
      let LabelsLookup = this.LookUpNamesDetail(ClinicalData, "Component");
      let VesselComponentLookup = this.LookUpNames(ClinicalData, "Vessel");
      let VesselComponentLookupDetail = this.LookUpNamesDetail(ClinicalData, "Vessel");
      let MeasurementTypeLookup = this.LookUpNames(ClinicalData, "MeasurementType");
      let SurgeonLookup = this.LookUpNames(ClinicalData, "Surgeon");
      let ProjectLookup = this.LookUpNames(ClinicalData, "Project");


      for (let index = 0; index < Object.keys(MeasurementTypeLookup).length; index++) {
        const element = Object.keys(MeasurementTypeLookup)[index];
        if (MeasurementTypeLookup[element] && MeasurementTypeLookup[element].indexOf("Imaging") > -1)
        {
          MeasurementTypeLookup[element] = "Imaging";
        }
        if (MeasurementTypeLookup[element] && MeasurementTypeLookup[element].indexOf("Transit") > -1&& MeasurementTypeLookup[element].indexOf("TransitTrend") === -1)
        {
          //Check that Transit exists for general flow but don't force trend curves to be transit.
          MeasurementTypeLookup[element] = "Flow";
        }
      }
      let IntuiLabelsLookup = this.LookUpIntuiNames();
      let IntuiLocationDefinitionsLookup = this.GenerateIntuiLocationDefintions(ClinicalData, "LocationDefinition", LabelsLookup, IntuiLabelsLookup);
  
      let indexGradings = this.parseIndexGradings(this.getFirstChildElement(ClinicalData, "IndexGradings") as Element);
      let referenceValues = this.parseIndexConfigurations(this.getFirstChildElement(ClinicalData, "IndexConfigurations") as Element, indexGradings);

      previewModel.referenceValues = referenceValues;
      let patients = this.getChildElements(this.getFirstChildElement(ClinicalData, "Patients") as Element, "Patient");
      for (let index = 0; index < patients.length; index++) {
        const element = patients[index];
        let procsOut = this.processProcedureNode( userId, previewModel.softwareVersion, isIntui, element, previewModel.procedures.length,  previewModel.serialNumber, previewModel.hospitalName , AnatomicalLocationLookup, VesselComponentLookup,VesselComponentLookupDetail, MeasurementTypeLookup, LabelsLookup, IntuiLocationDefinitionsLookup, SurgeonLookup, ProjectLookup , otherFiles);
        let privateDataOut = this.processProcedureNodePrivateFields(element, previewModel.procedures.length);
        //Now we also want to process limited personal data that we can display in the upload screen to assist in inputting the actual id.
  
  
        for (let index = 0; index < procsOut.length; index++) {
          const procOut = procsOut[index];
          privateProcs.push(privateDataOut[index]);
          previewModel.procedures.push(procOut);
          let procMetadata: PreviewProcedureMetadataModel ={
            id: procOut.id,
            index: previewModel.procedures.length,
            existing: false,
            selected: false,
            processed: 0,
            uploaded: 0,
            measurements: []
          };
          for (let index = 0; index < procOut.measurements.length; index++) {
            let measMetadata: PreviewMetadataMeasurement ={
              id: procOut.measurements[index].id,
              index: index,
              existing: false
            };
            procMetadata.measurements.push(measMetadata);
          }
          metadataModel.procedures.push(procMetadata);
        }
  
      }
  
       return {previewModel, procedures: privateProcs, metadata: metadataModel};
    }
}